import { useSyncExternalStore } from 'react';

const noSubscribe = () => () => {};

/**
 * False on the server and during hydration, true afterwards. Values that only the browser knows (runtime config, a
 * stored portal session) are read behind it, so the prerendered HTML and the first client render agree.
 */
export function useHydrated(): boolean {
  return useSyncExternalStore(
    noSubscribe,
    () => true,
    () => false,
  );
}
